import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const submitWaitlist = (payload) => api.post("/waitlist", payload);
export const submitContact = (payload) => api.post("/contact", payload);
export const submitFranchise = (payload) => api.post("/franchise", payload);
